// extracted by mini-css-extract-plugin
export var blue = "_4e-h";
export var brand = "_4e-d";
export var darkGrey = "_4e-g";
export var disabled = "_4e-6";
export var disabledSubtle = "_4e-7";
export var error = "_4e-8";
export var green = "_4e-i";
export var grey = "_4e-f";
export var icon = "_4e-0";
export var inherit = "_4e-c";
export var lightGrey = "_4e-e";
export var orange = "_4e-k";
export var pink = "_4e-m";
export var primary = "_4e-1";
export var purple = "_4e-n";
export var quaternary = "_4e-4";
export var quinary = "_4e-5";
export var red = "_4e-l";
export var secondary = "_4e-2";
export var success = "_4e-b";
export var tertiary = "_4e-3";
export var warning = "_4e-9";
export var warningSecondary = "_4e-a";
export var white = "_4e-o";
export var yellow = "_4e-j";